<template>
  <div>
    <div class="col-sm-12">
      <div class="h-title">{{$t('Security.auth.fun')}}</div>
      <div class="res-tree-box h-security-role-rightTree">
        <tree
          :setting="resourceAuthSetting"
          :nodes="resourceAuthNodes"
          @onCreated="handleResourceAuthCreated"
          @onCheck="checkResourceNode"/>
      </div>
    </div>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'

export default {
  name: 'AddRoleP3',
  components: {
    tree
  },
  data () {
    return {
      roleId: '',
      resourceAuthTreeObj: '',
      resourceAuthNodes: [],
      resourceAuthSetting: {
        data: {
          key: {
            name: 'nameStr'
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: 0
          }
        },
        check: {
          chkboxType: { 'Y': 'ps', 'N':'s' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      resourceIdChecked: []
    }
  },
  methods: {
    handleResourceAuthCreated(ztreeObj) {
      this.resourceAuthTreeObj = ztreeObj
      this.resourceAuthTreeObj.expandAll(true)
      this.setResourceChecked()
    },
    initTreeData() {
      this.findAuthData()
    },
    findAuthData() {
      const url = "/lte/ems/res/findResourceAll";
      this.axios.get(url, { params: {} }).then(response => {
        const result = response.data;
        this.resourceAuthNodes = result
      })
    },
    checkResourceNode(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const checkedStatus = treeNode.checked
      this.checkedSubNode(subNodes, checkedStatus)
      this.setChildProps()
    },
    checkedSubNode(subNodes, checkedStatus) {
      if (!!subNodes) {
        // 子节点勾选
        subNodes.forEach(node => {
          this.resourceAuthTreeObj.checkNode(node, checkedStatus, true, false)
        });
      }
    },
    setResourceChecked() {
      this.resourceIdChecked.forEach(item => {
        let pnode = this.resourceAuthTreeObj.getNodeByParam('id', item.resId, this.resourceAuthTreeObj.getNodeByParam('id', item.leafId))
        this.resourceAuthTreeObj.checkNode(pnode, true, false, false)
      })
    },
    setChildProps() {
      let resourceCheckedNodes = this.resourceAuthTreeObj.getCheckedNodes(true)
      let resourceIds = []
      resourceCheckedNodes.forEach(node => {
        let parentId = null;
        if(parseInt(node.id)>=1000){
          parentId = node.parentId;
        }
        resourceIds.push({resId: node.id, leafId: parentId})
      })
      this.$emit("childProps", {
        permission: resourceIds
      });
    },
    init(roleParams){
      this.roleId = roleParams.roleId;
      this.resourceIdChecked = roleParams.resourceIdList;
      this.$emit("childProps", {
        permission: this.resourceIdChecked
      });
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.tree-box {
  width: 720px;
  max-height: 450px;
}
</style>

